import { render } from "./CGZSubtype.vue?vue&type=template&id=4ae40583&scoped=true"
import script from "./CGZSubtype.vue?vue&type=script&lang=js"
export * from "./CGZSubtype.vue?vue&type=script&lang=js"

import "./CGZSubtype.vue?vue&type=style&index=0&id=4ae40583&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae40583"]])

export default __exports__